/* eslint-disable react/prop-types */
import 'babel-polyfill'
import React from 'react'
import F2AppContainer from '../../../../F2AppContainer'
import { APP_IDS, EVENT_NAMES } from '../../../../../../utils/f2Constants'
import TokenEvents from '../../../TokenEvents'
import Tabs from '../../../../../Lib/Tabs/Tabs'
import styles from './Ownership.module.scss'
import { changeTabHandler, getSymbolFromPath } from '../../../../utils'
import { emitF2Event, registerF2OnEvent } from '../../../../../../utils/f2Methods'
class OwnershipPage extends React.Component {
  constructor (props) {
    super(props)
    this.symbolRecvd = this.props.match.params.symbol
    this.state = {
      period: 'Annual',
      symbol: 'MSFT'
    }
  }

  componentDidMount () {
    registerF2OnEvent(EVENT_NAMES.MOD_GOTO, (modGotoContext) => {
      emitF2Event(EVENT_NAMES.SYMBOL_CHANGED_EVENT, {symbol: modGotoContext.symbol})
    })
  }

  emilPeriodUpdate = event => {
    emitF2Event(EVENT_NAMES.PERIOD_CHANGED_EVENT, event.currentTarget.getAttribute('data-value'))
  }

  emitSymbolChangedEvent = () => {
  }

  render () {
    return (
      <div data-page='F2AppContainer'>
        <div className={styles.header}>
          <h3>Quotes & Research</h3>

        </div>
        <div>
          <F2AppContainer
            appId={APP_IDS.COM_PERSHING_NETXWEALTH_UNIVERSALSEARCH}
            rootId={APP_IDS.COM_PERSHING_NETXWEALTH_UNIVERSALSEARCH} />
        </div>
        <div data-ipc-container={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_QUOTE_BAR} >
          <F2AppContainer
            removeApp
            appId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_QUOTE_BAR}
            context={{ symbol: getSymbolFromPath(this.symbolRecvd) }}
            rootId={APP_IDS.COM_PERSHING_NETXWEALTH_STOCK_QUOTE_BAR} />
        </div>

        <div className={styles.quoteAndResearch}>
          <Tabs id={'MainPage_tab'} ariaLabel={'Finanace tabs'} activeTab={'Ownership'} onClick={(k) => { changeTabHandler(k) }}>
            <div key='Snapshot' label='Snapshot' />
            <div key='charts' label='Charting' />
            <div key='Options' label='Options' />
            <div key='dividends' label='Dividends' />
            <div key='NewsAndResearch' label='News & Research' />
            <div key='Valuations' label='Valuations' />
            <div key='EarningsAndEstimates' label='Earnings & Estimates' />
            <div key='Fundamentals' label='Fundamentals' />
            <div key='Ownership' label='Ownership'>
              <div data-ipc-container={APP_IDS.COM_PERSHING_NETXWEALTH_TOP_FUND_HOLDERS} >
                <F2AppContainer
                  appId={APP_IDS.COM_PERSHING_NETXWEALTH_TOP_FUND_HOLDERS}
                  context={{ symbol: getSymbolFromPath(this.symbolRecvd) }}
                  rootId={APP_IDS.COM_PERSHING_NETXWEALTH_TOP_FUND_HOLDERS} />
              </div>
            </div>
          </Tabs>
        </div>
        <TokenEvents />
      </div>
    )
  }
}

export default OwnershipPage
